// This file was automatically generated from ptdata.model.order.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ptdata.model.order');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.order.displayTestNames = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.testNames) {
    var tList21462 = opt_data.testNames;
    var tListLen21462 = tList21462.length;
    for (var tIndex21462 = 0; tIndex21462 < tListLen21462; tIndex21462++) {
      var tData21462 = tList21462[tIndex21462];
      output.append((opt_data.noHighlight) ? soy.$$escapeHtml(tData21462) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(tData21462)) : soy.$$escapeHtml(tData21462)), (! (tIndex21462 == tListLen21462 - 1)) ? ', ' : '');
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.order.orderNoteExtraInfo = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.followUpMethod || opt_data.dateForTest) ? ' ' + ((! opt_data.noParens) ? '(' : '') + ((opt_data.followUpMethod) ? (opt_data.noHighlight) ? soy.$$escapeHtml(opt_data.followUpMethod) + ((opt_data.dateForTest) ? ', ' : '') : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.followUpMethod)) : soy.$$escapeHtml(opt_data.followUpMethod)) + ((opt_data.dateForTest) ? ', ' : '') : '') + ((opt_data.dateForTest && ! opt_data.followUpMethod) ? 'Date for test: ' + soy.$$escapeHtml(opt_data.dateForTest) : '') + ((opt_data.dateForTest && opt_data.followUpMethod) ? 'date for test: ' + soy.$$escapeHtml(opt_data.dateForTest) : '') + ((! opt_data.noParens) ? ')' : '') : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.order.orderNoteSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.ptdata.model.order.displayTestNames(soy.$$augmentData(opt_data, {noHighlight: true}), output);
  output.append(' order.');
  el8.template.ptdata.model.order.orderNoteExtraInfo(soy.$$augmentData(opt_data, {noHighlight: true}), output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.order.orderFeedSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.ptdata.model.order.displayTestNames(soy.$$augmentData(opt_data.order, {noHighlight: false}), output);
  if (! opt_data.noExtraInfo) {
    el8.template.ptdata.model.order.orderNoteExtraInfo(opt_data.order, output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.order.orderPatientSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.order.modelClass == 'LabOrder') {
    output.append('Lab Tests');
  } else {
    el8.template.ptdata.model.order.displayTestNames(soy.$$augmentData(opt_data.order, {noHighlight: true}), output);
  }
  el8.template.ptdata.model.order.orderNoteExtraInfo(soy.$$augmentData(opt_data.order, {noHighlight: true}), output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.order.ownedDocSummaryTag = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.standingOrderEndDate) ? 'Standing Order' : 'Order');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.order.ownedDocSummaryDescription = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.displayStatMethod) ? '!!' + soy.$$escapeHtml(opt_data.displayStatMethod) + '!! ' : '');
  el8.template.ptdata.model.order.displayTestNames(soy.$$augmentData(opt_data, {noHighlight: true}), output);
  el8.template.ptdata.model.order.orderNoteExtraInfo(soy.$$augmentData(opt_data, {noHighlight: true}), output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.order.reminderStatus = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.order.currentState == 'outstanding' && opt_data.order.reminder) ? '<div class="' + ((opt_data.reportFeed) ? 'el8333 el8StandardFontSize' : 'el8FeedColMainLine') + '">' + ((opt_data.order.reminder.isPast) ? 'Missed' : 'Upcoming') + ' reminder: ' + ((opt_data.reportFeed) ? '<a class="remind-later-trigger" data-reminder-id="' + soy.$$escapeHtml(opt_data.order.reminder.id) + '" tabindex="-1">' : '') + (soy.$$escapeHtml(opt_data.order.reminder.remindDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.order.reminder.remindDate)) : '') + ((opt_data.reportFeed) ? '</a>' : '') + '</div>' : '', (opt_data.order.currentState == 'cancelled') ? '<div class="' + ((opt_data.reportFeed) ? 'el8333 el8StandardFontSize' : 'el8FeedColMainLine') + '">Canceled on ' + (soy.$$escapeHtml(opt_data.order.currentStateTime)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.order.currentStateTime)) : '') + ((opt_data.order.currentStateNote) ? ' &ndash; ' + soy.$$escapeHtml(opt_data.order.currentStateNote) : '') + '</div>' : '', (opt_data.order.currentState == 'fulfilled') ? '<div class="' + ((opt_data.reportFeed) ? 'el8333 el8StandardFontSize' : 'el8FeedColMainLine') + '">Order fulfilled ' + ((opt_data.order.currentStateNote) ? ' &ndash; ' + soy.$$escapeHtml(opt_data.order.currentStateNote) : '') + ((opt_data.order.resolvingDocumentId) ? '<a href="TODO">View Report</a>' : '') + '</div>' : '');
  if (!opt_sb) return output.toString();
};
